import App from './App'
// 引入uvUI
import uvUI from '@/uni_modules/uv-ui-tools'

// import Vconsole from "vconsole";
//开发环境使用，生产环境自动取消
// new Vconsole();


// #ifndef VUE3
import Vue from 'vue'
Vue.config.productionTip = false
App.mpType = 'app'
Vue.use(uvUI);
try {
	function isPromise(obj) {
		return (!!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function");
	}
	// 统一 vue2 API Promise 化返回格式与 vue3 保持一致
	uni.addInterceptor({
		returnValue(res) {
			if (!isPromise(res)) {
				return res;
			}
			return new Promise((resolve, reject) => {
				res.then((res) => {
					if (res[0]) {
						reject(res[0]);
					} else {
						resolve(res[1]);
					}
				});
			});
		},
	});
} catch (error) {}
const app = new Vue({
	...App
})
app.$mount()
// #endif

// #ifdef VUE3
import { createSSRApp } from 'vue'
// 引入状态管理（如果需要请打开注释）
import { setupStore, store } from '@/store'

import { onMounted, onUnmounted } from 'vue'

import { userStorage } from '@/hooks/useStorage';
const { removeStorage } = userStorage();


function handleGlobalBeforeUnload(event) {
	// removeStorage('pid')
	// removeStorage('detail_url')
	// event.returnValue = '您确定要离开吗？';
}

function addGlobalEventListeners() {
	window.addEventListener('beforeunload', handleGlobalBeforeUnload);
}

function removeGlobalEventListeners() {
	window.removeEventListener('beforeunload', handleGlobalBeforeUnload);
}

export function createApp() {
	const app = createSSRApp(App)
	app.use(uvUI)
	setupStore(app)

	// 使用组合式API来管理生命周期钩子
	app.config.globalProperties.$removeGlobalListeners = removeGlobalEventListeners;

	onMounted(() => {
		addGlobalEventListeners();
	});

	onUnmounted(() => {
		removeGlobalEventListeners();
	});

	return {
		app,
		store
	}
}

// 添加全局监听器
addGlobalEventListeners();

// 注意：确保在应用销毁前移除监听器以避免内存泄漏
window.addEventListener('unload', () => {
	removeGlobalEventListeners();
});

// #endif